import { NUANCE_TAG_SERVER_NAME } from "@/constants";

export type NuanceConfig = {
  dataCenter: string;
  tagServerName: string;
  vendorUUID: string;
};

export const NUANCE_CONFIG: NuanceConfig = {
  dataCenter: "eu2",
  tagServerName: NUANCE_TAG_SERVER_NAME ?? "",
  vendorUUID: "10007081",
};
